export default "__VITE_ASSET__ChSVUkv2__"